module.exports = __webpack_public_path__ + "img/oddboot_dark_bg.c3d9a27a.jpg";